import React from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import PriceSummary from '@apps/card/components/PriceSummary';
import { StationeryPrintOrderDetailsFragment } from '@graphql/generated';
import ReceiptBlock from '@apps/card/components/Blocks/ReceiptBlock';
import { themeIdToTitle } from '@apps/card/Card.utils';
import { useTranslation } from '@shared/core';
import { usePrintJobDetailsTelemetryProxyContext } from '../../PrintJobDetailsTelemetryProxyContext';

const Column = ({ children, title }: { title: string; children: React.ReactNode }) => {
  return (
    <Flex flexDirection="column" rowGap={6} flex={1}>
      <TextV2 typographyVariant="hed3">{title}</TextV2>
      {children}
    </Flex>
  );
};

// const Block = ({ children, title }: { title: string; children: React.ReactNode }) => {
//   return (
//     <Flex flexDirection="column" rowGap={5}>
//       <TextV2 typographyVariant="hed1">{title}</TextV2>
//       {children}
//     </Flex>
//   );
// };

/**
 * TODO:
 *  - Need some way to get payment method
 */
export const PaymentSummary = ({ order }: { order: StationeryPrintOrderDetailsFragment }) => {
  const telemetryContext = usePrintJobDetailsTelemetryProxyContext();
  const { t } = useTranslation('stationery');
  const categoryName = t('stationeryTemplateCategoryToTile', order.cardDraft.stationeryTemplate.category)?.();

  return (
    <Flex width={'100%'} maxWidth="100%" alignSelf="center" paddingX={{ _: 6, md: 0 }} flexDirection={{ _: 'column', md: 'row' }} rowGap={10} columnGap={140}>
      <Column title="Order Summary">
        <PriceSummary promotion={order.discount} templateCategory={order.cardDraft.stationeryTemplate.category} cardConfig={order.cardDraft.cardJSON} priceUpTo="total" flex={1}>
          {summary => (
            <>
              <ReceiptBlock title={categoryName} subTitle={themeIdToTitle(order.cardDraft.stationeryTemplate.themeId)} lines={summary.card} />
              <ReceiptBlock title="Back" lines={summary.back} />
              <ReceiptBlock title="Envelope" lines={summary.envelope} />
              <ReceiptBlock title="Shipping Method" lines={summary.shipping} />
            </>
          )}
        </PriceSummary>
      </Column>

      <Column title="">
        {/* Hiding the following until we resolve the nullable `paymentInfo` field issue */}
        {/* <Block title="Credit or Debit Card">
          <TextV2 typographyVariant="label2">Visa ending 8456</TextV2>
        </Block> */}

        <Flex flexDirection="column" rowGap={5}>
          <TextV2>Need help with your order?</TextV2>
          <ButtonV2
            as="a"
            href="mailto:printsupport@withjoy.com"
            variant="outline"
            intent="neutral"
            shape="rounded"
            width={{ _: '100%', xs: 304 }}
            onClick={() => telemetryContext?.onContactSupportClick()}
          >
            Contact Support
          </ButtonV2>
        </Flex>
      </Column>
    </Flex>
  );
};
